module.exports = __webpack_public_path__ + "static/media/img_14.5107ff46.png";